"use client";

import * as SliderPrimitive from "@radix-ui/react-slider";
import * as React from "react";

import { cn } from "../../lib/utils";

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center h-6 px-2.5",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-[#E5E7EB]">
      <SliderPrimitive.Range className="absolute h-full bg-[#FF8C70]" />
    </SliderPrimitive.Track>
    {Array.isArray(props.value || props.defaultValue) ? (
      // Multiple thumbs for range selection
      (props.value || props.defaultValue || []).map((_, idx) => (
        <SliderPrimitive.Thumb
          key={idx}
          className="block h-5 w-5 rounded-full border-2 border-white bg-[#FF8C70] ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF8C70] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
        />
      ))
    ) : (
      // Single thumb for regular slider
      <SliderPrimitive.Thumb className="block h-5 w-5 rounded-full border-2 border-white bg-[#FF8C70] ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF8C70] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" />
    )}
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
